'use strict';

angular.module('rating')
  .factory('Rating', ['http', 'bulk', 'sock', 'user', '$q', function (http, bulk, sock, user, $q) {

    function Rating(data) {}

    Rating.get = function (id, type) {
      if (user.guest) return $q.resolve(null);

      return bulk.get(id, 'api/rating/' + type).then(function (res) {
        return res.rating;
      }).catch(function () {
        return null;
      });

    };

    Rating.rate = function (id, type, rating) {
      return http().post('api/rating/' + type + '/' + id, $.param({ rating: rating }))
        .then(function (res) {
          sock.publish('rating.update', {
            id: id,
            rating: res.data.rating,
            personalRating: rating
          });
          return res.data.rating;
        });
    };

    return Rating;

  }]);
